var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.hiddenHeader === true)?_c('div',[_c('router-view')],1):_c('div',[_c('appHeader',{attrs:{"headerType":_vm.headerType}}),_c('transition',{attrs:{"name":"fade","mode":"out-in"}}),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }